import {  useEffect, useState } from 'react'; 
import { curationApiUrl} from "../config/default";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import EmbryoImage from './embryo-image';

import "../css/image-browser-table.css";

export default function ExperimentPageImages(props: any) {
    const {exp_hier, index} = props;
    const [imagesData, setImagesData] = useState<any>([]);
    const [imagesDataNew, setImagesDataNew] = useState<any>([]);


    useEffect(() => {
        if(!exp_hier)
        {
          return;
        }
        
        const fetchData = async () => { 
            if(exp_hier )
            {
              let _imagesDataTemp:any = [];
                const images = await fetch(curationApiUrl + "/EmbryoImages/externalImages?container="+
                exp_hier,
                                      {mode:"cors"})
                                    .then(res => res.json());

                if(images.data && images.data.length>0)
                {
                  let images_data: any[] = [];
                  for(let i=0; i < images.data.length; i+=1) {

                    images_data.push(
                      { "exp_embryo":images.data[i].metadata["exp_embryo"],  
                      "exp_hier":images.data[i].metadata["exp_hier"], 
                      "genotype":images.data[i].metadata["genotype"], 
                      "image":images.data[i].metadata["image"], 
                      "is_blue":images.data[i].metadata["is_blue"],
                      "img_hier": images.data[i].metadata["img_hier"],
                      "sections_link": images.data[i].metadata["sections_link"],
                      "file_data": images.data[i].metadata['file_data']
                      }
                    );
                  }
                  setImagesDataNew(images_data);
                }


                if(images.data && images.data.length>0)
                {
                  let imagesDataObj:any = {};
                  for(let imageItem of images.data)
                  {
                    if(imageItem.metadata)
                    {
                      if(imageItem.metadata.exp_embryo) {
                      if((imageItem.metadata.exp_embryo+"") in imagesDataObj)
                        imagesDataObj[imageItem.metadata.exp_embryo+""].push(imageItem);
                      else
                        imagesDataObj[imageItem.metadata.exp_embryo+""] = [imageItem];
                    }
                  }
                  }

                  const embryoKeys = Object.keys(imagesDataObj).map(Number).sort(function(a, b) {
                    return a - b;
                  });
                  for(let k of embryoKeys)
                  {
                    _imagesDataTemp.push({embryo:k, images:imagesDataObj[k]});
                  }
                }
              setImagesData(_imagesDataTemp);
            }
           
        };
  
    
        fetchData()
        .catch((error)=>{
        });
  
    }, [exp_hier]);
 

    const getExperimentImagesOfGenotype = (genotype:any) => {
      if(!imagesDataNew) {
          return null;
      }
      var img_subset = imagesDataNew.filter(function(itm:any) {
        return itm.genotype === genotype
      });
      if(img_subset.length === 0)
        return null;
      return img_subset;
    }


    const groupExperimentImagesByGenotype = (genotype:any) => {
      if(!imagesDataNew) {
          return null;
      }
      let listed: any = [];
      var subset_of_images = getExperimentImagesOfGenotype(genotype);
      for(let i=0; i < subset_of_images.length; i+=1) {
          let imgItem = subset_of_images[i];
          let keep_tissue = false;
          if(imgItem.genotype !== null && genotype !== null) {
              if(imgItem.genotype === genotype) {
                  keep_tissue = true;
              }
          }
          else if(imgItem.genotype === null && genotype === null) {
              keep_tissue = true;
          }
          else {
              continue;
          }
          if (keep_tissue === true) {
              listed.push({embryo: imgItem.exp_embryo, image: imgItem.image, item: imgItem});
          }
      }
      listed.sort(function(a:any,b:any) {return a.embryo - b.embryo||a.image - b.image});
      let html_obj: any[] = [];
      for(let i=0; i < listed.length; i+=1) {
          let imgItem = listed[i].item;
          html_obj.push(
            <EmbryoImage imgItem={imgItem}></EmbryoImage>
          )     
      }
      return(
          <div>
              {html_obj}
          </div>
         )  
  };



  const experimentImageBrowserByGenotype = () => {
    let genotypes = ['tandem', 'single', 'random', "none", null];
    let browserRows: any[] = [];
    genotypes.forEach(function(genotype:any){
        if(getExperimentImagesOfGenotype(genotype) !== null){
        let genotype_str = "undetermined";
        if(genotype !== null) {
            genotype_str = genotype;
        }

        browserRows.push(
            <TableRow style={{"verticalAlign": "top"}}>
                 <TableCell><b>{genotype_str}</b></TableCell>
                 <TableCell>
                    {groupExperimentImagesByGenotype(genotype)}
                </TableCell>

            </TableRow>
        )
      }
    });

    return(
        <Table>
        <TableHead style={{"backgroundColor":"#8fb5ba"}}>
            <TableRow>
                <TableCell style={{"width":"10%"}}>Genotype</TableCell>
                <TableCell style={{"width":"90%"}}>Reference</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {browserRows}
        </TableBody>
    </Table>

    )

}

  return(
    <div>
      {experimentImageBrowserByGenotype()}
    </div>
  )


      
   
   
  }